<template>
  <div id="uploader">
    <div class="bj disflex"
         :style="isSimple?'background:linear-gradient(270deg,#FFB357,#DE4D35);':'background:linear-gradient(270deg,rgba(25,51,144,1),rgba(24,94,211,1));'">
      <img v-if="isUpload == 'true'"
           style="width:30vw"
           :src="logosrc"
           alt />
      <div v-if="isUpload == 'false'"
           @click="goBack"
           class="disflex">
        <img width="7vw"
             src="@/assets/uploader/back.png"
             alt="">
        <p>返回</p>
      </div>
      <div class="disflex">
        <img style="width:4.6vw;"
             src="@/assets/uploader/clock.png"
             alt />
        <p>{{hour + ' : ' + minute + ' : ' + second}}</p>
        <!-- <p>{{zjytime}}</p> -->
      </div>
    </div>

    <router-view />
  </div>
</template>

<script>
import { getMobileUpdateUrl } from "@/api/userCenter";
import { getAppBaseConfig } from "@/api/config";
import { mapActions } from 'vuex'
import Vue from 'vue';
import { Toast } from 'vant';

Vue.use(Toast);
export default {
  data () {
    return {
      hour: "00",
      minutes: 0,
      seconds: 0,
      isUpload: localStorage.getItem('isUpload'),
      zjytime: '00:00:00',
      logosrc: '',
    };
  },
  watch: {
    second: {
      handler (newVal) {
        this.num(newVal);
      }
    },
    minute: {
      handler (newVal) {
        this.num(newVal);
      }
    },
    '$store.state.user.isUpload' (data) {
      // this.isUpload = data
      this.isUpload = localStorage.getItem('isUpload')
    }
  },
  computed: {
    second: function () {
      return this.num(this.seconds);
    },
    minute: function () {
      return this.num(this.minutes);
    }
  },

  methods: {
    ...mapActions(["setIsUpload"]),
    goBack () {
      // console.log(this.$route)
      this.$router.go(-1)
      this.setIsUpload(true)
    },

    openClick () {

    },
    num (n) {
      return n < 10 ? "0" + n : "" + n;
    },
    timer () {
      var _this = this;
      var time = window.setInterval(function () {
        if (_this.seconds === 0 && _this.minutes !== 0) {
          _this.seconds = 59;
          _this.minutes -= 1;
        } else if (_this.minutes === 0 && _this.seconds === 0) {
          _this.seconds = 0;
          window.clearInterval(time);
        } else {
          _this.seconds -= 1;
        }
        if (_this.seconds === 0 && _this.minutes === 0) {
          Toast('上传时间已到');
          _this.$router.push({ name: 'timeout' })
        }
      }, 1000);
    },

    transTime (time) {
      if (time === "") {
        return "";
      } else {
        var result = "";
        if (time >= 1000) {
          var day = parseInt(time / (24 * 60 * 60 * 1000));
          var hour = parseInt(
            (time % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000)
          );
          var minute = parseInt(
            ((time % (24 * 60 * 60 * 1000)) % (60 * 60 * 1000)) / (60 * 1000)
          );
          var second = parseInt(
            (((time % (24 * 60 * 60 * 1000)) % (60 * 60 * 1000)) %
              (60 * 1000)) /
            1000
          );
          // if (day != 0) {
          //   result += day + "天";
          // }
          // if (hour != 0) {
          //   result += hour + "时";
          // }
          this.minutes = minute
          this.seconds = second
          // console.log(second)
          // if (minute < 10) {
          //   result = '00:' + '0' + minute + ":" + second;

          // }
          // if(second < 10){
          //   result = '00:' + '0' + minute + ":" + '0' + second;

          // }
          // if (second != 0) {
          //   result += second;
          // }
          // console.log(result)
          if (minute === 0 && second === 0) {
            this.$router.push({ name: 'timeout' })
            // Toast('上传时间已到');
          }
        }
        // return result
        // this.zjytime = result
      }
    },

    getUploader () {
      setInterval(() => {
        this.isUpload = localStorage.getItem('isUpload')

      }, 200);
    },
    //获取应用基础配置
    async getAppBaseConfigAsync () {
      let { status, data, message } = await getAppBaseConfig();
      if (status) {
        if (data.logo) {
          this.logosrc = data.logo
        } else {
          if (this.isSimple) {
            this.logosrc = require('@/assets/simple/logo-m.png')
          } else {
            this.logosrc = require('@/assets/login/yunzhiLogo.png')
          }
        }
      }
    },
  },
  created () {
    this.getAppBaseConfigAsync()
    setInterval(() => {
      let date = new Date()
      date = date.getTime(date)
      let cha = parseInt(this.$store.state.user.expirationTime) - date
      if (cha < 0) {
        this.$router.push({ name: 'timeout' })
      }
      this.transTime(cha)

    }, 1000);

    this.getUploader()

    console.log(this.isUpload)
  },
  mounted () {
    this.timer();
  }
};
</script>

<style lang="scss" scoped>
@import "./uploadbj.scss";
</style>